
import { useBooks } from "@/services";
import { BookStatus, BookStatusEntry } from "@/types";
import { defineComponent, computed, ref, onMounted } from "vue";
import BookUploaderListItem from "./BookUploaderListItem.vue";

import Spinner from "@/components/shared/Spinner.vue";
export default defineComponent({
  components: { Spinner, BookUploaderListItem },
  setup() {
    const perPage = 10;
    let currentPage = ref(1);
    const bookStore = useBooks();
    const keyword = ref("");
    const isLoading = ref(false);
    const books = computed(() => filterBooks(keyword.value, bookStore.books));
    const sortedList = computed(() =>
      [...books.value].sort(
        (a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf()
      )
    );
    const totalRows = computed(() => sortedList.value.length);
    const paginationItems = computed(() =>
      sortedList.value.slice(
        perPage * (currentPage.value - 1),
        currentPage.value * perPage - 1
      )
    );

    onMounted(() => init());

    async function init() {
      isLoading.value = true;
      await bookStore.loadBooks();
      isLoading.value = false;
    }

    function filterBooks(keyword: string, bookEntries: BookStatusEntry[]) {
      if (keyword === "") {
        return bookEntries;
      }

      const lowerCaseKeyword = keyword.toLowerCase();
      return bookEntries.filter(
        (x) =>
          x.name.toLowerCase().includes(lowerCaseKeyword) ||
          x.statusId.toLowerCase().includes(lowerCaseKeyword)
      );
    }

    return {
      currentPage,
      books,
      isLoading,
      keyword,
      BookStatus,
      totalRows,
      perPage,
      paginationItems,
    };
  },
  methods: {
    openBookUploader() {
      useBooks().clearFile();
      this.$bvModal.show("book-upload-modal");
    },
  },
});
